import type { MutationOptions } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import { GET_BLOCKS_DELIVERYMAN } from './constants';
import { apiClient } from '@/_config/lib/axios/api-client';

type DeleteBlockDeliverymanParams = {
  deliverymanId: string;
  blockId: string;
};

const deleteBlockDeliveryman = (params: DeleteBlockDeliverymanParams) => {
  const { deliverymanId, blockId } = params;

  return apiClient
    .delete<boolean>(`entregadores/${deliverymanId}/remove-block/${blockId}`)
    .then(response =>
      handleResponseSuccess(
        response.data,
        'O bloqueio foi removido com sucesso!',
      )(),
    )
    .catch(handleResponseThrowError());
};

const useDeleteBlockDeliveryman = ({
  onSuccess,
  ...options
}: MutationOptions<boolean, unknown, DeleteBlockDeliverymanParams> = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteBlockDeliveryman,
    onSuccess: (...args) => {
      queryClient.invalidateQueries([GET_BLOCKS_DELIVERYMAN], { exact: false });
      onSuccess?.(...args);
    },
    ...options,
  });
};

export { useDeleteBlockDeliveryman };
